














































































import { BankCustodian } from "@/admin/types";
import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useCardCustomizationStore } from "@/admin/store/cardCustomization";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class CardCustomization extends Vue {
  $validator: Validator;
  listIsChanging = false;
  custodian: BankCustodian;
  newCustomizationName = "";
  newCustomizationValue = "";

  cardCustomizationStore = useCardCustomizationStore();
  rolePermissionsStore = useRolePermissionsStore();

  created () {
    this.custodian = this.cardCustomizationStore.custodiansAllowingCustomization[0];
    this.onCustodianSet();
  }

  @Watch("custodian")
  onCustodianSet () {
    this.cardCustomizationStore.loadCardCustomizations(this.custodian);
  }

  get isLoading () {
    return this.cardCustomizationStore.isLoadingCardCustomizations;
  }

  customizationsTableHeadings = [
    {
      key: "cardStockNickname",
      label: "Name",
      thClass: "text-left",
    },
    {
      key: "cardStockOpaqueId",
      label: "Card Program ID",
      thClass: "text-left",
    },
  ];

  get customizationsTableFields () {
    return this.cardCustomizationStore.didLoadCardCustomizations ? this.cardCustomizationStore.cardCustomizations : [];
  }

  onNewCustomizationEdited () {
    this.$validator.validate();
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDebitCardCustoEdit);
  }

  onCreateClicked () {
     if (this.listIsChanging) { return; }
     this.listIsChanging = true;
     this.$validator.validate()
      .then(result => {
        if (result) {
          return this.cardCustomizationStore.createCardCustomization({
            custodian: this.custodian,
            cardStockOpaqueId: this.newCustomizationValue,
            CardStockNickname: this.newCustomizationName
          });
        }
      })
      .finally(() => { this.listIsChanging = false; });
  }
}
